import React, { useCallback } from "react";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import type { TextFieldComponent } from "@mapmycustomers/ui";
import { TextField } from "@mapmycustomers/ui";

export const TEXT_FILTER_OPERATORS = [
  FilterOperator.CONTAINS,
  FilterOperator.NOT_CONTAINS,
  FilterOperator.EQUALS,
  FilterOperator.NOT_EQUAL,
  FilterOperator.STARTS_WITH,
  FilterOperator.ENDS_WITH,
  FilterOperator.DOES_NOT_START_WITH,
  FilterOperator.DOES_NOT_END_WITH,
];

interface TextFilterProps extends IFilterComponentProps {}

const TextFilter: IFilterInstance = {
  doesSupportValue: (value: any, operator: FilterOperator) => {
    return typeof value === "string" && TEXT_FILTER_OPERATORS.includes(operator);
  },
  getComponent:
    (): React.FunctionComponent<TextFilterProps> =>
    ({ className, disabled, focus, onChange, placeholder, value }) => {
      const setRef = useCallback(
        (ref: null | TextFieldComponent) => {
          if (focus && ref) {
            ref.focus();
          }
        },
        [focus]
      );

      return (
        <TextField
          className={className}
          disabled={disabled}
          onChange={(text) => onChange?.({ ...value, value: text })}
          placeholder={placeholder as string}
          ref={setRef}
          size="middle"
          value={value?.value}
        />
      );
    },
};

export default TextFilter;
